import Module from '../../Module';
import mock from './mock';
import { Address } from '../';
import services from 'core/services';
// import { Dialog } from 'core/components';

class UserService extends Module {
  /** @inheritdoc */
  get baseURL() {
    return '/api/v1/customers'
  }

  /** @inheritdoc */
  initMock(handler) {
    mock(this.handler)
  }

  /**
   * Parse user received from backend
   * @param {Object} user user for parse
   * @return {Object}
   */
  parseUser(user) {
    if (!user) return null

    return {
      address: user.address,
      birthday: user.birthday,
      code: user.code,
      createdAt: user.createdAt,
      currentCredit: user.currentCredit,
      currentPoint: user.currentPoint,
      customerName: user.customerName,
      deletedAt: user.deletedAt,
      email: user.email,
      fatherName: user.fatherName,
      firstName: user.firstName,
      genderId: user.genderId,
      id: user.id,
      joinDate: user.joinDate,
      lastName: user.lastName,
      mobile: user.mobile,
      password: user.password,
      referralCode: user.referralCode,
      remainCredit: user.remainCredit,
      status: user.status,
      storeId: user.storeId,
      storeName: user.storeName,
      totalCredit: user.totalCredit,
      totalPoint: user.totalPoint,
      updatedAt: user.updatedAt,
      username: user.username,
      addresses: user.addresses ? Address.parseAddressables(user.addresses) : []
    }
  }

  /**
   * Get current authorized user
   * @return {Promise}
   */
  profile(params) {
    return new Promise((resolve, reject) => {
      this.handler
        .get(`${this.baseURL}`, { params })
        .then(r => {
          resolve(
            this.parseResponse(r, data => ({
              customer: this.parseUser(data.customer)
            }))
          )
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  forgetPassword(data, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .post(`${this.baseURL}/forgot/mobile`, {
          data: data,
          params: params
        })
          .then(r => {
            resolve(r)
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }

  ForgetPasswordCode(data, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .post(`${this.baseURL}/forgot/code`, {
          data: data,
          params: params
        })
          .then(r => {
            resolve(r)
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }

  forgetPasswordFinalize(data, params) {
    return new Promise((resolve, reject) => {
      this.handler
        .put(`${this.baseURL}/password`, {
          data: data,
          params: params
        })
          .then(r => {
            resolve(r)
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }
}

export default new UserService()
